import React, { useState, useContext, useEffect, useRef } from "react";
import { useSpring, animated } from "react-spring";
import { useParams } from "react-router-dom";
import { Editor, EditorState, RichUtils, convertFromRaw, convertToRaw } from "draft-js";
import { ReactComponent as TRASH } from "../../assets/icons/Trash.svg";

import { Bold, Check, Info, Italic, List, Plus, Underline } from "react-feather";

import { FormTextInput } from "../../Components/FormTextInput";
import { FormTextArea } from "../../Components/FormTextArea";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";

import { languages } from "../../Data/languages";

import { InvoiceToPrint } from "../../Components/InvoicePrint";
import { TbEdit } from "react-icons/tb";

import { saveAs } from "file-saver";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import PopUpModal from "../../NewComponents/PopUpModal";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import OrderSummary from "../Order/components/OrderSummary";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import { ORDERSTATUS, REF_LABELS_COLORS } from "../../Data/statuses";

import { ReactComponent as DOWNLOAD } from "../../assets/icons/Download.svg";
import { ReactComponent as EMPTYSTAR } from "../../assets/icons/empty-star.svg";
import { ReactComponent as CHECK } from "../../assets/icons/CheckmarkСircleFill.svg";
import { ReactComponent as DELETE } from "../../assets/icons/delete.svg";
import { ReactComponent as CANCELORDER } from "../../assets/icons/cancel-order.svg";
import { ReactComponent as ORDERSUCCESS } from "../../assets/icons/order-success.svg";
import { ReactComponent as Copy } from "../../assets/icons/copy.svg";
import { ReactComponent as CopyunSelect } from "../../assets/icons/CopyunSelect.svg";


import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import NewButton from "../../NewComponents/NewButton";
import {
  checkAutoBilling,
  formatTotal,
  getDiscount,
  getDue,
  getExpedited,
  getTotal,
  updateInvoiceClientName,
} from "../../Data/Functions";

import OrderChatBox from "../../Components/OrderChatBox";

import "./SingleOrder.css";
import TranslatorDropdown from "../Account/OrdersComponents/TranslatorDropdown";
import { AccountType, EAST1, EAST4 } from "../../utility/enums";
import AddCommentonDocument from "../../NewComponents/AddComment/AddCommentonDocument";
import EverbaryChatBox from "../../Components/EverbaryChatBox";
import axios from "axios";
import AddfilesPopUpModel from "../../NewComponents/AddfilesPopUpModel";
import { v4 as uuidv4 } from 'uuid';
import OrderTranslation from "../Order/components/OrderTranslation";
import AddCommentonTranslatedFiles from "../../NewComponents/AddComment/AddCommentonTranslatedFiles";
import OrderProgress from "../../NewComponents/OrderProgress";
import OrderTranslationAfterApprove from "../Order/components/OrderTranslationAfterApprove";
import { file } from "jszip";
import { fieldValue, firestore, getFullHttpUrl, storage } from "../../firebase.config";
import { getBlob } from "@firebase/storage";
import MessageDot from "../../NewComponents/MessageDot";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import GetFileTypeElement from "../../Data/Functions/getFileType";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const SingleOrderBackend = ({ windowSize }) => {
  const { setColor } = useContext(TransitionContext);

  const { showNotification } = useContext(NotificationContext);

  const { signedIn } = useContext(AuthContext);

  const { userData, teamData } = useContext(DataContext);

  const { transitionTo } = useScreenTransition();

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const { orderID } = useParams();

  const [orderInfo, setOrderInfo] = useState(null);
  const [loadedOrder, setLoadedOrder] = useState(false);

  const [selectedSendPayment, setSelectedSendPayment] = useState("");

  const [cancelBtnText, setCancelOrder] = useState("Cancel Order");
  const [markasPaidBtn, setMarkasPaidBtn] = useState("Mark as Paid");
  const [approveBtnText, setApproveBtnText] = useState("Approve Translation");

  const [fileIconTooltip, setFileIconTooltip] = useState("");
  const [fileOverlayText, setFileOverlayText] = useState("Copy file name");

  const [moreOptions, setMoreOptions] = useState(false);
  const [editReview, setEditReview] = useState(false);
  const [showApproveTranslation, setShowApproveTranslation] = useState(false);
  const [showReviewPopUp, setShowReviewPopUp] = useState(false);
  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);
  const [showTranslatedFileHoverBox, setShowTranslatedFileBox] = useState(false);
  const [filesMoreOptions, setFilesMoreOptions] = useState(null);
  const [showAddTranslatedFiles, setShowAddTranslatedFiles] = useState(false)
  const [showAddSourceFiles, setShowAddSourcefiles] = useState(false)
  const [aiModalFile, setAiModalFile] = useState(null);
  const [orderUpdated, setOrderUpdated] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [trackingID, setTrackingID] = useState("");
  const [aiModelTranslateBtn, setAiModelTranslateBtn] = useState("Translate");
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createEmpty()
  );

  const [reviewRating, setReviewRating] = useState(0);
  const [saveReviewBtn, setSaveReviewBtn] = useState("Save");
  const [reviewText, setReviewText] = useState("");
  const [reviewSubmitButton, setReviewSubmitButton] = useState("Submit Review");

  const [teamUsers, setTeamUsers] = useState([]);
  const [newCCEmail, setNewCCEmail] = useState("");

  const [ccedEmails, setCCedEmails] = useState([]);
  const [addCCEmailBtnTxt, setAddCCEmailBtnTxt] = useState("Add");
  const [deleteBtnText, setDeleteBtnText] = useState("Delete");
  const [saveClientBtnTxt, setSaveClientBtnTxt] = useState("Save");
  const [showDeleteReview, setShowDeleteReview] = useState(false);
  const statusOverlayProps = useSpring({ display: "none" });

  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [clients, setClients] = useState([]);

  const [addCommentFile, setAddCommentFile] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(null);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [documentName, setDocumentName] = useState('');
  const [loading, setLoading] = useState(false);
  const componentRef = useRef();
  const [addCommentTranslatedFile, setAddCommentonTranslatedFile] = useState(null);
  const [notarizationService, setNotarizationService] = useState(false);
  const [hardCopyService, setHardCopyService] = useState(false);
  const [supportNotes, setSupportNotes] = React.useState(() => EditorState.createEmpty());
  const [openReplyBox, setOpenReplyBox] = useState(false);
  const [supportReplyNotes, setSupportReplyNotes] = React.useState(() => EditorState.createEmpty());

  const [translatorNotes, setTranslatorNotes] = React.useState(() => EditorState.createEmpty());

  const [clientRevisionNotes, setClientRevisionNotes] = React.useState(() => EditorState.createEmpty());

  const [translatorNotesClient, setTranslatorNotesClient] = React.useState(() => EditorState.createEmpty());
  const [translatedfiles, setTranslatedfiles] = useState([]);
  const [sourceFiles, setSourceFiles] = useState([]);
  
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [showMaunallyPayModal, setShowMaunallyPayModal] = useState(false);
  const [showApproveCancellation, setShowApproveCancellation] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState("");

  const [showEditPagesModal, setShowEditPagesModal] = useState(false);
  const [editPagesCount, setEditPagesCount] = useState("");

  const now = new Date();

  useEffect(() => {
      if(!signedIn || (userData && userData.role === "client")){
        return transitionTo("/");
      }
    }, [signedIn, userData]);

  useEffect(() => {
    if (signedIn && userData ) {

      firestore
        .collection("users")
        .get()
        .then((qSnap) => {
          if (!qSnap.empty) {
            setClients(
              qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
        });
    }
  }, [signedIn, userData]);

  useEffect(() => {
    

    const unsub = firestore
      .collection("orders")
      .doc(orderID)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            setOrderInfo({ ...doc.data(), id: doc.id });
            //set ccEmails for team
            if (doc.data().teamId && doc.data().ccedEmails) {
              setCCedEmails(doc.data().ccedEmails);
            }
            if (doc.data().teamId && doc.data().clientFirstName) {
              setClientFirstName(doc.data().clientFirstName);
              setClientLastName(doc.data().clientLastName);
            }
            if (doc.data().notes && doc.data().notes.blocks) {
              setEditorState(
                EditorState.createWithContent(convertFromRaw(doc.data().notes))
              );
            }


            if (doc.data().supportNotes) {
              setSupportNotes(EditorState.createWithContent(convertFromRaw(doc.data().supportNotes)))
            }

            if (doc.data().translatorNotes) {
              setTranslatorNotes(EditorState.createWithContent(convertFromRaw(doc.data().translatorNotes)))
            }

            if (doc.data().supportReply) {
              setSupportReplyNotes(EditorState.createWithContent(convertFromRaw(doc.data().supportReply)))
            }

            if (doc.data().clientRevisionNotes) {
              setClientRevisionNotes(EditorState.createWithContent(convertFromRaw(doc.data().clientRevisionNotes)));
            }

            if (doc.data().translatorNotesClient) {
              setTranslatorNotesClient(EditorState.createWithContent(convertFromRaw(doc.data().translatorNotesClient)))
            }

            if (doc.data().notes && doc.data().notes.blocks) {
              setEditorState(
                EditorState.createWithContent(convertFromRaw(doc.data().notes))
              );
            }

            if (
              !doc.data().shownConfirmation &&
              doc.data().status !== "created"
            ) {
              firestore
                .collection("orders")
                .doc(orderID)
                .update({ shownConfirmation: true });
            }
            setLoadedOrder(true);
            sleep(500).then(() => {
              if (
                (windowSize.width > 767 ||
                  windowSize.orientation === "landscape") &&
                document.getElementById("mainPrimary") &&
                document.getElementById("mainSecondary")
              ) {
                if (
                  document.getElementById("mainPrimary").clientHeight >
                  document.getElementById("mainSecondary").clientHeight
                ) {
                  document.getElementById("mainSecondary").style.height = `${document.getElementById("mainPrimary").clientHeight
                    }px`;
                } else {
                  document.getElementById("mainPrimary").style.height = `${document.getElementById("mainSecondary").clientHeight
                    }px`;
                }
              }
            });
          } else {
            transitionTo("/office/orders")
            showNotification(
              "Error",
              "An error ocurred loading the order info. Try again. If it persists, please contact Support.",
              "error"
            );
          }
        },
        (error) => {
          //console.log(error);
          showNotification(
            "Error",
            "An error ocurred loading the order info. Try again. If it persists, please contact Support.",
            "error"
          );
        }
      );

      return () => unsub();
  }, [orderID, orderUpdated]);

  useEffect(() => {
    if (userData && userData.teamId && orderInfo && orderInfo.teamId) {
      firestore
        .collection("users")
        .where("teamId", "==", orderInfo.teamId)
        .where("email", "!=", orderInfo.email)
        .orderBy("email", "asc")
        .get()
        .then((querySnap) => {
          setTeamUsers(
            querySnap.docs.map((doc) => {
              return { id: doc.id, ...doc.data() };
            })
          );
        });
    }


    setNotarizationService(orderInfo?.notarizationStatus === "completed" ? true : false);
    setHardCopyService(orderInfo?.hardCopyStatus === "shipped" ? true : false);
    setTrackingID(orderInfo?.hardCopyTrackingID);

  }, [orderInfo, userData]);


  const checkHowDidYouHearInDB = async () => {
    if(orderInfo && orderInfo.userID){
      await firestore.collection("howDidTheyHear").doc(orderInfo.userID).get().then((doc) => {
        if(doc.exists){
          setHowDidYouHear(doc.data().howDidYouHear);
        }
      });
    }else{
      await firestore.collection("howDidTheyHear").where("email", "==", orderInfo.email).get().then((qSnap) => {
        if(qSnap.empty){
          return;
        }
        const doc = qSnap.docs[0];
        if(doc.exists){
          setHowDidYouHear(doc.data().howDidYouHear);
        }
      });
    }

  }

  const [howDidYouHear, setHowDidYouHear] = useState(null);

  useEffect(() => {
    if(orderInfo && orderInfo.howDidYouHear){
      setHowDidYouHear(orderInfo.howDidYouHear);
    }else if(orderInfo){
      checkHowDidYouHearInDB();
    }

  }, [orderInfo])

  const formatDate = (timestamp) => {
    if (String(timestamp).length === 10) {
      timestamp *= 1000;
    }

    const date = new Date(timestamp);

    const options = { month: "short", day: "2-digit", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;

    return `${formattedDate} @${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };


  const formatDiscount = (value) => {
    return "-$" + value.toFixed(2);
  };

  const handleApproveTranslation = () => {
    setApproveBtnText("Approving...");
    
    const now = new Date();

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        status: "completed",
        clientApproved: true,
        completed: now.getTime(),
        notarizationStatus: "queue",
        hardCopyStatus: "queue",
      })
      .then(() => {
        setShowApproveTranslation(false);
        setApproveBtnText("Approve Translation");
        setShowReviewPopUp(true);
        showNotification(
          "Success",
          "The order has been successfully approved.",
          "success"
        );
      })
      .catch(() => {
        setApproveBtnText("Approve Translation");
        showNotification(
          "Error",
          "An error ocurred approving the order. Please, try again. If it persists, contact Support.",
          "error"
        );
      });
  };

  const handleDeleteReview = async () => {
    setDeleteBtnText("Deleting...");

    

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        reviewRating: null,
        reviewText: null,
      })
      .then(() => {
        firestore
          .collection("reviews")
          .where("orderID", "==", orderInfo.id)
          .get()
          .then((querySnap) => {
            if (querySnap.empty) {
              return;
            } else {
              firestore
                .collection("reviews")
                .doc(querySnap.docs[0].id)
                .delete()
                .then(() => {
                  showNotification(
                    "Success",
                    "Review deleted successfully.",
                    "success"
                  );
                  setMoreOptions(false);
                  setDeleteBtnText("Delete");
                  setShowDeleteReview(false);
                  setReviewText("");
                  setReviewRating(0);
                  setOrderUpdated((o) => !o);
                })
                .catch((error) => {
                  setDeleteBtnText("Delete");
                  showNotification(
                    "Error",
                    "An error ocurred while deleting the review. Please, try again.",
                    "error"
                  );
                });
            }
          });
      })
      .catch((error) => {
        setDeleteBtnText("Delete");
        showNotification(
          "Error",
          "An error ocurred while deleting the review. Please, try again.",
          "error"
        );
      });
  };

  const handleSubmitReview = async () => {
    setReviewSubmitButton("Submitting...");

    const now = new Date();

    firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        reviewRating:
          reviewRating.toString().length === 1
            ? reviewRating.toString() + ".0"
            : reviewRating.toString(),
        reviewText: reviewText,
      })
      .then(() => {
        firestore
          .collection("reviews")
          .add({
            orderID: orderInfo.id,
            userID: userData.id,
            name: orderInfo.name,
            languageFrom: getLanguage(orderInfo.languageFrom),
            languageTo: getLanguage(orderInfo.languageTo),
            score:
              reviewRating.toString().length === 1
                ? reviewRating.toString() + ".0"
                : reviewRating.toString(),
            text: reviewText,
            date: now.getTime(),
            email: orderInfo.email,
          })
          .then(() => {
            showNotification(
              "Success",
              "Thanks for leaving a review!.",
              "success"
            );
            setReviewSubmitButton("Submit Review");
            setShowReviewPopUp(false);
            setOrderUpdated((o) => !o);
          })
          .catch((error) => {
            showNotification(
              "Error",
              "An error ocurred while submitting the review. Please, try again.",
              "error"
            );
            setReviewSubmitButton("Submit Review");
          });
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while submitting the review. Please, try again.",
          "error"
        );
        setReviewSubmitButton("Submit Review");
      });
  };

  // const updateClientsName = () => {
    

  //   firestore
  //     .collection("clients")
  //     .where("name", "==", clientFirstName + " " + clientLastName)
  //     .where("teamId", "==", userData.teamId)
  //     .get()
  //     .then((qSnap) => {
  //       if (!qSnap.empty) {
  //         qSnap.docs.forEach((doc) => {
  //           firestore
  //             .collection("clients")
  //             .doc(doc.id)
  //             .update({
  //               orderCount: doc.data().orderCount + 1,
  //             })
  //             .catch((error) => {
  //               showNotification(
  //                 "Error",
  //                 "An error ocurred while saving client name. Please, try again.",
  //                 "error"
  //               );
  //               setSaveClientBtnTxt("Save");
  //             });
  //         });
  //       } else {
  //         firestore
  //           .collection("clients")
  //           .add({
  //             orderCount: 1,
  //             fistName: clientFirstName,
  //             lastName: clientLastName,
  //             name: clientFirstName + " " + clientLastName,
  //             teamId: userData.teamId,
  //           })
  //           .catch((error) => {
  //             showNotification(
  //               "Error",
  //               "An error ocurred while saving client name. Please, try again.",
  //               "error"
  //             );
  //             setSaveClientBtnTxt("Save");
  //           });
  //       }
  //     })
  //     .catch((error) => {
  //       showNotification(
  //         "Error",
  //         "An error ocurred while saving client name. Please, try again.",
  //         "error"
  //       );
  //       setSaveClientBtnTxt("Save");
  //     });
  // };

  const handleSaveClientName = async () => {
    if (clientFirstName === "") {
      showNotification(
        "Error",
        "Empty Client Name, please enter a client name.",
        "error"
      );
      return;
    }
    setSaveClientBtnTxt("Saving...");

    await firestore
      .collection("orders")
      .doc(orderInfo.id)
      .update({
        clientFirstName: clientFirstName,
        clientLastName: clientLastName,
      })
      .then(async() => {
        await updateInvoiceClientName(orderInfo, clientFirstName, clientLastName);
        // updateClientsName();
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred while saving client name. Please, try again.",
          "error"
        );
        setSaveClientBtnTxt("Save");
      })
      .finally(() => {
        setSaveClientBtnTxt("Save");
        setOrderUpdated((o) => !o);
      });
  };

  const addCCedEmail = (email) => {
    if (addCCEmailBtnTxt === "Adding..") {
      return;
    }
    

    const emailRegex = new RegExp(
      "^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$"
    );
    const lowerCaseEmail = email.toLowerCase();
    // let EmailMatched = false;

    if (email === "" || !emailRegex.test(lowerCaseEmail)) {
      showNotification(
        "Error",
        "Invalid Email, please enter valid email.",
        "error"
      );
      return;
    }
    setAddCCEmailBtnTxt("Adding..");

    // teamUsers.forEach(user => {
    //   if(user.email === lowerCaseEmail){
    //     EmailMatched = true;
    //     return;
    //   }
    // })

    if (
      (ccedEmails.length > 0 && ccedEmails.includes(lowerCaseEmail)) ||
      orderInfo.email === lowerCaseEmail
    ) {
      showNotification(
        "Error",
        "Email already exist, please enter another email.",
        "error"
      );
      return;
    }
    firestore
      .collection("orders")
      .doc(orderID)
      .update({
        ccedEmails: [...ccedEmails, lowerCaseEmail],
      })
      .then(() => {
        setOrderUpdated((o) => !o);
      })
      .catch((e) => {
        showNotification("Error", "Error occured please try again", "error");
      });
    setNewCCEmail("");
    setAddCCEmailBtnTxt("Add");
    showNotification("Email added", "Email added successfully.", "success");
  };

  const removeCCedEmail = (email) => {
    

    firestore
      .collection("orders")
      .doc(orderID)
      .update({
        ccedEmails: ccedEmails.filter((e) => e !== email),
      })
      .catch((e) => {
        showNotification("Error", "Error occured please try again", "error");
      });
  };

  const getFullAddress = (address) => {
    const parts = [
      address.firstName && address.firstName !== "Undefined"
        ? address.firstName || address.recipient
        : "",
      address.lastName && address.lastName !== "Undefined"
        ? address.lastName
        : "",
      address.country && address.country !== "Undefined" ? address.country : "",
      address.region && address.region !== "Undefined" ? address.region : "",
      address.city && address.city !== "Undefined" ? address.city : "",
      address.zipCode && address.zipCode !== "Undefined" ? address.zipCode : "",
      address.street && address.street !== "Undefined" ? address.street : "",
      address.apartment && address.apartment !== "Undefined"
        ? address.apartment
        : "",
    ].filter(Boolean);

    return parts.join(", ");
  };

  const handleCancelOrder = (isPaid) => {
    
    setCancelOrder("Cancelling...");

    firestore
      .collection("orders")
      .doc(orderID)
      .update({
        status: isPaid ? "on-hold" :
          orderInfo.status === "new" || orderInfo.status === "draft"
            ? "cancelled"
            :  "on-hold",
          cancellationHold: isPaid ? true:
          orderInfo.status === "new" || orderInfo.status === "draft"
            ? false
            :  true
      })
      .then(() => {
        setCancelOrder("Cancel");
        setShowCancelModal(false);
        setOrderUpdated((o) => !o);

      })
      .catch((e) => {
        setCancelOrder("Cancelling...");
        showNotification(
          "Error",
          "Error occured cancelling the order please try again",
          "error"
        );
      });
  };


  const handleUpdateTranslator = (order, newTranslator) => {
    const { id, status } = order;
    if (id && newTranslator) {
      const due = getDue(true,order);
      const now = new Date();

      
      const updateRecord = {
        translator: newTranslator,
        status: 'in-progress',
        due: due,
        overdue: false,
        assigned: now.getTime()
      };
      if (status === "new" || status === "Assigned" || status === "assigned") {
        updateRecord.status = "in-progress";
      }

      firestore
        .collection("orders")
        .doc(id)
        .update(updateRecord)
    }
  };

  const capitalize = text => {
    if (!text) {
      return '';
    }

    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  // const getBlob = async (fileRef) => {
  //   const url = await fileRef.getDownloadURL();
  //   const response = await fetch(url);
  //   return await response.blob();
  // };

  const downloadCoverSheetFile = async (file) => {
    if(!file.url){
      showNotification(
        "Error",
        "An error occurred while downloading the file.",
        "error"
      );
    }
    
    try {
      const fileRef = storage.ref().child(file.ref);
      getBlob(fileRef).then((blob) => saveAs(blob, file.name))
      // await fileRef.getMetadata();
      // const blob = await getBlob(fileRef);
      // saveAs(blob, name);
    } catch (error) {
      showNotification(
        "Error",
        "An error occurred while downloading the file.",
        "error"
      );
    }
  };

  const generateCoversheet = () => {
    const mDocName = `${documentName}-${capitalize(orderInfo.languageFrom)} to ${capitalize(orderInfo.languageTo)}-${orderInfo.orderNumber}`;
    setDocumentName('');

    if (!orderInfo.files.some(file => file.name === mDocName || file.name === mDocName + '.docx')) {
      setLoading(true);
      axios({
        method: 'post',
        url: getFullHttpUrl("generateCoversheet", EAST4),
        data: {
          docName: mDocName,
          orderID: orderInfo.id,
          languageFrom: orderInfo.languageFrom,
          languageTo: orderInfo.languageTo,
          translatorCertification: orderInfo.translatorCertification ? orderInfo.translatorCertification : false,
        }
      })
        .then((response) => {
          showNotification("Success", "The coversheet for your file has been successfully created.", "success");
        })
        .catch((error) => {
          showNotification("Error", "An error ocurred generating the coversheet. Please, try again. If it persists, contact technical support.", "error");
        }).finally(
          setLoading(false)
        );
    } else {
      showNotification("Error", "There's already a file with that name. Please, try again.", "error");
    }

  }
  const handletranslatedFiles = async (e) => {
    const mFiles = e.target.files;

    const oID = orderInfo.id;

    for (let i = 0; i < mFiles.length; i++) {
      const fileID = uuidv4();
      setTranslatedfiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading' }]));
    }

    const storageRef = storage.ref();

    for (let i = 0; i < mFiles.length; i++) {
      const subFolder = uuidv4();
      const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);

      const downloadToken = uuidv4();

      const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");

      const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;

      var metadata = {
        firebaseStorageDownloadTokens: downloadToken,
        customMetadata: {
          'orderID': oID
        }
      }

      const uploadTask = fileRef.put(mFiles[i], metadata);

      setTranslatedfiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));

      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setTranslatedfiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
      }, (error) => {
        // setTranslatedfiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed' } : file));
        setTranslatedfiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
        showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
      }, () => {
        setTranslatedfiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: now.getTime() } : file));
      });
    }

  }

  const handleDeleteTranslatedFile = async (file, notify = true) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    if (file.ref && (file.status === "complete" || file.timestamp)) {
      try {
        const storageRef = storage.ref();
        const fileRef = storageRef.child(file.ref);
  
        setTranslatedfiles((prevFiles) =>
          prevFiles.map((mFile) =>
            checkFile(mFile, file) ? { ...mFile, status: "deleting" } : mFile
          )
        );
  
  
        await fileRef.delete();
  
        setTranslatedfiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
  
        if (notify) {
          showNotification("Success", "File deleted successfully.", "success");
        }
      } catch (error) {
        console.error("Delete error:", error);
        if (notify) {
          showNotification("Delete Error", "Failed to delete file. Please try again.", "error");
        }
           setTranslatedfiles((prevFiles) =>
             prevFiles.map((mFile) =>
               checkFile(mFile, file) ? { ...mFile, status: "complete" } : mFile
             )
           );
         }
      }else if (file.status === 'failed') {
        setTranslatedfiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
      } else {
        file.task.cancel();
        setTranslatedfiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
      }
  };

  const CancelAddTranslatedFiles = () => {
    setShowAddTranslatedFiles(false)
    setTranslatedfiles([]);
    translatedfiles.map(file =>
      handleDeleteTranslatedFile(file, false)
    )
  }

  const handleSubmitTranslatedFiles = async (orderStatus) => {
    const files = translatedfiles
      ?.filter((f) => f.ref && f.url && f.status === "complete")
      .map((file) => ({
        name: file.name,
        ref: file.ref,
        url: file.url,
        type: "translation",
        size: file.file ? file.file.size : file.size,
        format: file.file ? file.file.type : file.format,
        timestamp: file.timestamp,
        orderStatus: orderStatus
      }));

    if (!files.length) {
      showNotification("Warning", "No valid files to upload.", "warning");
      return;
    }

    
    const orderRef = firestore.collection("orders").doc(orderID);

    try {
      await orderRef.update({
        files: fieldValue.arrayUnion(...files),
        // status: orderInfo.status === "revision" ? "revision" : "support-review",
      });
      setShowAddTranslatedFiles(false)
      showNotification("Success", "Files successfully added to the order.", "success");
      setTranslatedfiles([])
    } catch (error) {
      showNotification("Error", "Failed to update order with files.", "error");
      console.error("Error updating order with files:", error);
    }
  };

  const handleSourceFiles = async (e) => {
    const mFiles = e.target.files;

    const oID = orderInfo.id;

    for (let i = 0; i < mFiles.length; i++) {
      const fileID = uuidv4();
      setSourceFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading' }]));
    }

    const storageRef = storage.ref();

    for (let i = 0; i < mFiles.length; i++) {
      const subFolder = uuidv4();
      const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);

      const downloadToken = uuidv4();

      const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");

      const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;

      var metadata = {
        firebaseStorageDownloadTokens: downloadToken,
        customMetadata: {
          'orderID': oID
        }
      }

      const uploadTask = fileRef.put(mFiles[i], metadata);

      setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));

      uploadTask.on('state_changed', (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
      }, (error) => {
        // setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed' } : file));
        setSourceFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
        showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
      }, () => {
        setSourceFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: now.getTime() } : file));
      });
    }

  }

  const handleDeleteSourceFile = async (file, notify = true) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    if (file.ref && (file.status === "complete" || file.timestamp)) {
      try {
        const storageRef = storage.ref();
        const fileRef = storageRef.child(file.ref);
  
        setSourceFiles((prevFiles) =>
          prevFiles.map((mFile) =>
            checkFile(mFile, file) ? { ...mFile, status: "deleting" } : mFile
          )
        );
  
  
        await fileRef.delete();
  
        setSourceFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
  
        if (notify) {
          showNotification("Success", "File deleted successfully.", "success");
        }
      } catch (error) {
        console.error("Delete error:", error);
        if (notify) {
          showNotification("Delete Error", "Failed to delete file. Please try again.", "error");
        }
           setSourceFiles((prevFiles) =>
             prevFiles.map((mFile) =>
               checkFile(mFile, file) ? { ...mFile, status: "complete" } : mFile
             )
           );
         }
      }else if (file.status === 'failed') {
        setSourceFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
      } else {
        file.task.cancel();
        setSourceFiles((prevFiles) => prevFiles.filter((mFile) => !checkFile(mFile, file)));
      }
  };

  const CancelAddSourceFiles = () => {
    setShowAddSourcefiles(false)
    setSourceFiles([]);
    sourceFiles.map(file =>
      handleDeleteSourceFile(file, false)
    )
  }

  const handleSubmitSourceFiles = async () => {
    const files = sourceFiles
      ?.filter((f) => f.ref && f.url && f.status === "complete")
      .map((file) => ({
        name: file.name,
        ref: file.ref,
        url: file.url,
        type: "source",
        size: file.file ? file.file.size : file.size,
        format: file.file ? file.file.type : file.format,
        timestamp: file.timestamp,
      }));

    if (!files.length) {
      showNotification("Warning", "No valid files to upload.", "warning");
      return;
    }

    
    const orderRef = firestore.collection("orders").doc(orderID);

    try {
      await orderRef.update({
        files: fieldValue.arrayUnion(...files),
      });
      setShowAddSourcefiles(false)
      showNotification("Success", "Files successfully added to the order.", "success");
      setSourceFiles([])
    } catch (error) {
      showNotification("Error", "Failed to update order with files.", "error");
      console.error("Error updating order with files:", error);
    }
  };

  const deleteFileFromOrderHandler = async (file) => {
    if (!file.ref) {
      console.error("File reference missing for:", file);
      showNotification("Error", "File reference is missing.", "error");
      return;
    }
    setDeleteBtnText("Deleting...")
    
    const orderRef = firestore.collection("orders").doc(orderID);
    const storageRef = storage.ref();
    const fileRef = storageRef.child(file.ref);

    try {
      // Remove the file from Firestore order document
      await orderRef.update({
        files: fieldValue.arrayRemove(file),
      });

      // Delete the file from Firebase Storage
      await fileRef.delete();

      showNotification("Success", "File deleted from order.", "success");

      // Remove file from local state instantly for UI feedback
      setTranslatedfiles((prevFiles) => prevFiles.filter((mFile) => mFile.id !== file.id));

      // Fetch latest order data from Firestore
      const updatedOrderSnapshot = await orderRef.get();
      const updatedOrderData = updatedOrderSnapshot.data();

      // Check if all translated files are deleted
      const remainingFiles = updatedOrderData.files.filter(f => f.type === 'translation');

      // if (file.type === "translation" && remainingFiles.length === 0) {
      //   await orderRef.update({ status: "in-progress" });
      //   showNotification("Status Updated", "All translated files deleted, status reverted to In Progress.", "success");
      // }

      setSourceFiles((prevFiles) => prevFiles.filter((mFile) => mFile.id !== file.id));

    } catch (error) {
      console.error("Error deleting file:", error);
      showNotification("Error", "Failed to remove file from order. Please try again.", "error");
    }finally{
      setShowDeleteModal(null);
      setDeleteBtnText("Delete");
    }
  };


  const [showTranslationApproval, setShowTranslationApproval] = useState(false);

  const handleNotarizationClick = () => {
    setNotarizationService((prev) => !prev);
    setShowTranslationApproval(true);
  };

  const handleHardCopyClick = () => {
    setHardCopyService((prev) => !prev);
    setShowTranslationApproval(true);
  };

 
  const downloadFile = (file) => {

    const {name, ref, url} = file;
    if(!url){
      return showNotification(
        "Error",
        "An error occurred while downloading the file.",
        "error"
      );
    }
    if(file.format === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
      try {
        const fileRef = storage.ref().child(ref);
        getBlob(fileRef).then((blob) => saveAs(blob, name))
      } catch (error) {
        showNotification(
          "Error",
          "An error occurred while downloading the file.",
          "error"
        );
      }
    }else{
      window.open(url, '_blank')
    }
}
  const handleDownloadFile = async (file) => {
    try {
      if (!file || !file.name || !file.ref) {
        showNotification("Error", "No file available for download.", "error");
        return;
      }
     downloadFile(file);
    } catch (error) {
      console.error("Download Error:", error);
      showNotification("Error", "Failed to download file.", "error");
    }
  };

  
  const handleMouseOver = (role) => {

    setShowTranslatedFileBox(true);
  };

  const handleMouseOut = () => {
    setShowTranslatedFileBox(false);

  };
  const toggleSupportReply = () => {
    setOpenReplyBox(o => !o);
  }
  const saveSupportReply = () => {

    firestore.collection('orders').doc(orderInfo.id)
      .update({
        supportReply: convertToRaw(supportReplyNotes.getCurrentContent()),
        supportReplyFlag: orderInfo.supportReplyFlag ? false : true
      })
      .then(() => {
        showNotification("Success", "Reply notes have been saved.", "success");
      })
      .catch(error => {
        showNotification("Error", "An error ocurred saving the notes. Please, try again. If it persists, contact technical support.", "error");
      })
  }

  const handleBoldClick = target => {
    if (target === 'supportNotes') {
      setSupportNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'BOLD'))
    } else if (target === 'supportReply') {
      setSupportReplyNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'BOLD'))
    }
  }

  const handleItalicClick = target => {
    if (target === 'supportNotes') {
      setSupportNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'ITALIC'))
    } else if (target === 'supportReply') {
      setSupportReplyNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'ITALIC'))
    }
  }

  const handleUnderlineClick = target => {
    if (target === 'supportNotes') {
      setSupportNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'))
    } else if (target === 'supportReply') {
      setSupportReplyNotes(editorState => RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'))
    }
  }

  const toggleUL = target => {
    if (target === 'supportNotes') {
      setSupportNotes(editorState => RichUtils.toggleBlockType(editorState, 'unordered-list-item'))
    } else if (target === 'supportReply') {
      setSupportReplyNotes(editorState => RichUtils.toggleBlockType(editorState, 'unordered-list-item'))
    }
  }

  const saveSupportNotes = () => {

    firestore.collection('orders').doc(orderInfo.id)
      .update({
        supportNotes: convertToRaw(supportNotes.getCurrentContent()),
        supportNotesFlag: orderInfo.supportNotesFlag ? false : true
      })
      .then(() => {
        showNotification("Success", "Comments saved succesfully!", "success");
      })
      .catch(error => {
        showNotification("Error", "An error ocurred saving the comments. Please, try again. If it persists, contact technical support.", "error");
      })
  }

  const handleMarkAsPaid = () => {
    setMarkasPaidBtn("Paying...");
    try{
        firestore.collection("orders").doc(orderInfo.id).update({
          paypalOrderID: "paid",
          orderPaidManually: true
        })
    }catch(e){
      showNotification("Error", "Error updating the order.", "error")
    }finally{
      setShowMaunallyPayModal(false);
      setMarkasPaidBtn("Mark as Paid");
    }
    
  }
  const handleMarkAsUnPaid = () => {
    if(orderInfo && orderInfo.orderInvoiceId){
      firestore.collection("orderInvocies").doc(orderInfo.invoiceId).update({
        status: "pay-later",
      })
    }else{
      firestore.collection("orders").doc(orderInfo.id).update({
        paypalOrderID: "pay-later",
      })
    }
    setShowMaunallyPayModal(false)
  }

  const handleApproveCancellation = (status) => {
    firestore.collection("orders").doc(orderInfo.id).update({status: status, cancellationHold: false}).then(() => {
      setShowApproveCancellation(false);
    })
  }

  const getAiTranslatedFile = async (file, orderInfo) => {
    setAiModelTranslateBtn("Translating...");

    axios.post(getFullHttpUrl("aut-translateFile", EAST4), {
        file: file,
        orderInfo: orderInfo
    }).then((res) => {
        setAiModelTranslateBtn("Translate");
        setAiModalFile(null);
        showNotification("Success", `${file.name} translated file will be added to the order shortly, please wait.`, "success");
    }).catch((err) => {
        console.log(err);
        setAiModelTranslateBtn("Translate");
        showNotification("Error", `Failed to translate file ${file.name}.`, "error");
    })
  }

  const copyFileName = (file) => {
    const fileName = file.name ? file.name.split(".").slice(0, -1).join(".") : "";
    if(!fileName) return;
    const copy = fileName + "-" + capitalize(orderInfo.languageFrom) + " to " + capitalize(orderInfo.languageTo) + "-" + orderInfo.orderNumber;
    navigator.clipboard.writeText(copy);

    setTimeout(() => {
      setFileIconTooltip("");
    }, 3000); // Reset after 3 seconds
    setTimeout(() => {
      setFileIconTooltip("");
      setFileOverlayText("Copy file name");
    }, 1000); // Reset after 3 seconds
    showNotification(
      fileName,
      "The file name has been successfully copied.",
      "success"
    );
    setFileOverlayText("Copied!");
  }


  const handleAddRefLabel = async(label, file) => {
    const updatedFile = { ...file, refLabel: file.refLabel ? [...file.refLabel, label] : [label] };
    const updatedFiles = orderInfo.files.map((mFile) => mFile.ref !== file.ref ? mFile : updatedFile);
    await firestore.collection("orders").doc(orderInfo.id).update({
      files: [...updatedFiles]
    });
    setFilesMoreOptions(null);
  }

  const handleDeleteRefLabel = async(label, file) => {
    const updatedFile = { ...file, refLabel: file.refLabel.filter((mLabel) => mLabel !== label) };
    const updatedFiles = orderInfo.files.map((mFile) => mFile.ref !== file.ref ? mFile : updatedFile);
    await firestore.collection("orders").doc(orderInfo.id).update({
      files: [...updatedFiles]
    });
    setFilesMoreOptions(null);
  }

  const [editPageBtnText, setEditPageBtnText] = useState("Save");

  const handleEditPages = async() => {
    if(editPagesCount === "" || editPagesCount === "0"){
      showNotification("Error", "Please enter a valid number of pages.", "error");
      return;
    }
    setEditPageBtnText("Saving...");
    const totalPrice = getTotal(orderInfo, editPagesCount) - getDiscount(orderInfo, editPagesCount);
    await firestore.collection("orderInvoices").doc(orderInfo.orderInvoiceId).update({
      totalPrice: totalPrice
    })
    await firestore.collection("orders").doc(orderInfo.id).update({
      pagesCount: editPagesCount
    }).then(async() => {
        setEditPageBtnText("Save");
        setEditPagesCount("");
        setShowEditPagesModal(false)
    }).catch((error) => {
      setEditPageBtnText("Save");
    });
  }

  const onChangePagesCount = (count) => {
    var reg = /^[0-9]+\.?[0-9]{0,3}$/;
    if (count === '' || reg.test(count)) {
      setEditPagesCount(count);
    }
  }


  return (
    <>
    {showEditPagesModal && (
              <PopUpModal
                title={"Edit Pages Count"}
                backBtnText={"Back to Order"}
                btnText={editPageBtnText}
                iconBgColor="#FFF6EA"
                showClose
                onClose={() => setShowEditPagesModal(false)}
                onClick={() => handleEditPages()}
                onBackClick={() => {
                  setShowEditPagesModal(false)
                }}
                customGap="gap-0"
                components={
                  <FormTextInput focus placeholder="Pages Count" value={editPagesCount} onChange={onChangePagesCount} />
                }
                hideIcon
                contentFullWidth
                disableBtn={editPageBtnText === "Saving..." || editPagesCount === "" || editPagesCount === "0"}
              >
              </PopUpModal>
            )}
    {moreOptions || filesMoreOptions ? (
      <div className="fixed top-0 left-0 w-full h-full z-index-1" onClick={() => {setMoreOptions(false); setFilesMoreOptions(false)}}>
      </div>
    ) : ""}
    {openInvoiceModal && <OpenInvoiceModal order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}
      {addCommentFile ? (
        <AddCommentonDocument
          selectedFile={addCommentFile}
          handleClose={() => setAddCommentFile(null)}
        />
      ) : addCommentTranslatedFile ? (
        <AddCommentonTranslatedFiles
          selectedFile={addCommentTranslatedFile}
          orderInfo={orderInfo}
          handleClose={() => setAddCommentonTranslatedFile(null)}
          userData={userData}
        />
      ) :
        (
          <>
            <animated.div
              style={statusOverlayProps}
              className="checkoutStatusOverlay"
            >
              We are finishing up. Please wait, this will take a second<span className="dotsLoading">...</span>
            </animated.div>

            {showApproveCancellation && (
              <PopUpModal
                title={"Approve Cancellation"}
                backBtnText="Refunded"
                subText="Approve the order to either 'Cancel' or 'Refund' status?"
                text={""}
                deleteBtn={true}
                btnText={"Cancelled"}
                iconBgColor="#FFF6EA"
                showClose
                onClose={() => setShowApproveCancellation(false)}
                onClick={() => handleApproveCancellation("cancelled")}
                onBackClick={() => {
                  handleApproveCancellation("refunded")
                }}
              >
                <CANCELORDER />
              </PopUpModal>
            )}

            {showMaunallyPayModal && (
              <PopUpModal
                title={"Mark Order as Paid"}
                backBtnText="Back to Order"
                subText="Are you sure you want to mark this order as Paid?"
                text={""}
                btnText={markasPaidBtn}
                iconBgColor="#FFF6EA"
                showClose
                onClose={() => setShowMaunallyPayModal(false)}
                onClick={handleMarkAsPaid}
                onBackClick={() => {
                  setShowMaunallyPayModal(false);
                }}
                disableBtn={markasPaidBtn === "Paying..."}
              >
                <CANCELORDER />
              </PopUpModal>
            )}

            {showCancelModal && (
              <PopUpModal
                title={"Cancel Order"}
                backBtnText="Back to Orders"
                subText="Are you sure you want to cancel this order?"
                text={(showCancelModal.orderNumber)}
                btnText={cancelBtnText}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                showClose
                onClose={() => setShowCancelModal(false)}
                onClick={() => handleCancelOrder(orderInfo.paypalOrderID !== "auto-billing" && orderInfo.paypalOrderID !== "pay-later")}
                onBackClick={() => {
                  setShowCancelModal("");
                }}
                disableBtn={cancelBtnText === "Cancelling..."}
                warningText={
                  orderInfo.paypalOrderID !== "auto-billing" && orderInfo.paypalOrderID !== "pay-later"
                    ? "The order has already been paid by the client. After canceling, the order status will change to 'on Hold' for refund to the client."
                    : false
                }
              >
                <CANCELORDER />
              </PopUpModal>
            )}
            {showDeleteReview && (
              <PopUpModal
                title={"Delete Review"}
                backBtnText="Cancel"
                subText=""
                text={"Are you sure you want to delete your review?"}
                btnText={deleteBtnText}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                showClose
                onClose={() => setShowDeleteReview(false)}
                onClick={() => handleDeleteReview()}
                onBackClick={() => {
                  setShowDeleteReview(false);
                }}
                disableBtn={deleteBtnText === "Deleting..."}
              >
                <DELETE />
              </PopUpModal>
            )}

            {showDeleteModal && (
              <PopUpModal
                title={"Delete File"}
                backBtnText="Cancel"
                text={"Are you sure you want to delete this file?"}
                subText={showDeleteModal.name}
                btnText={deleteBtnText}
                iconBgColor="#FFF6EA"
                deleteBtn={true}
                showClose
                onClose={() => setShowDeleteModal(null)}
                onClick={() => deleteFileFromOrderHandler(showDeleteModal)}
                onBackClick={() => {
                  setShowDeleteModal(null);
                }}
                disableBtn={deleteBtnText === "Deleting..."}
              >
                <DELETE />
              </PopUpModal>
            )}

            {aiModalFile && (
              <PopUpModal
                title={"AI Translation"}
                backBtnText="Close"
                text={"Are you sure you want to translate this file?"}
                subText={aiModalFile.name}
                btnText={aiModelTranslateBtn}
                iconBgColor="#FFF6EA"
                showClose
                onClose={() => setAiModalFile(null)}
                onClick={() => getAiTranslatedFile(aiModalFile, orderInfo, setAiModalFile, setAiModelTranslateBtn)}
                onBackClick={() => {
                  setAiModalFile(null);
                }}
                disableBtn={aiModelTranslateBtn === "Translating..."}
              >
                <DELETE />
              </PopUpModal>
            )}

            {showAddTranslatedFiles && (
              <AddfilesPopUpModel windowSize={windowSize} onCancel={CancelAddTranslatedFiles} files={translatedfiles} handleFiles={handletranslatedFiles} handleDeleteFile={handleDeleteTranslatedFile} onClose={() => setShowAddTranslatedFiles(false)} onSave={() => handleSubmitTranslatedFiles(orderInfo.status)} />
            )}

            {showAddSourceFiles && (
              <AddfilesPopUpModel windowSize={windowSize} onCancel={CancelAddSourceFiles} files={sourceFiles} handleFiles={handleSourceFiles} handleDeleteFile={handleDeleteSourceFile} onClose={() => setShowAddSourcefiles(false)} onSave={handleSubmitSourceFiles} />
            )}
            {selectedSendPayment !== "" && (
              <SendPaymentLinkPopUp
                data={selectedSendPayment}
                type={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? "invoice" : "order"}
                id={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? selectedSendPayment.orderInvoiceId : selectedSendPayment.id}
                onClose={() => setSelectedSendPayment("")}
              />
            )}

            <AccountNavBar
              windowSize={windowSize}
              selectedTab={"orders"}
              accountMainPadding={false}
              bgTransparent={true}
              breadLinkType="order"
              breadLink={`Order #${orderInfo ? (orderInfo.orderNumber) : ""
                }`}
              admin={true}
            >
              {!loadedOrder && (
                <NoData
                  loadingText="order"
                  type="order"
                  loading={true}
                  showBtn={false}
                />
              )}

              {loadedOrder && (
                <div className="mainOrderPageContainer">
                  <div className="mainOrderTitleWrapper">
                    <h2 className="createOrderNavbarMenuTitle">
                      Order #{(orderInfo.orderNumber)}
                    </h2>
                    <div className="mainOrderStatusWrap">
                      {showStatusHoverBox ? (
                        <div className="mainOrderStatusHover">
                          <p className="title">
                            Status:{" "}
                            {orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] : ORDERSTATUS[orderInfo.status.toLowerCase()][0]}
                          </p>
                          <p className="subTitle">
                            {orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][2] : ORDERSTATUS[orderInfo.status.toLowerCase()][2]}.
                          </p>
                        </div>
                      ) : null}
                      <div
                        className="mainOrderOrderStatus"
                        style={{
                          backgroundColor: orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][1] : ORDERSTATUS[orderInfo.status]
                            ? ORDERSTATUS[orderInfo.status][1]
                            : "",
                        }}
                        onMouseOver={() => setShowStatusHoverBox(true)}
                        onMouseOut={() => setShowStatusHoverBox(false)}
                      >
                        {orderInfo.status === "completed" ? "Approved" : orderInfo.cancellationHold && orderInfo.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] : (ORDERSTATUS[orderInfo.status]
                          ? ORDERSTATUS[orderInfo.status][0]
                          : orderInfo.status)}
                        <Info className="statusIcon" />
                      </div>
                    </div>
                  </div>
                  <div className="mainOrderSecondaryContent mainOrderTransBtnWrap">
                    {/* {userData &&
                      userData.id === orderInfo.userID &&
                      orderInfo &&
                      orderInfo.status === "user-review" &&
                      orderInfo.supportApproved && (
                        <NewButton
                          text={"Approve Translation"}
                          width={"100%"}
                          customIcon={<LIKE />}
                          smallPadding
                          onClick={() => setShowApproveTranslation(true)}
                        />
                      )} */}
                    {/* {orderInfo.status !== "created" && <NewButton text={"Cancel Order"} back whiteBtn width="100px" customIcon={<DOWNLOAD />} smallPadding onClick={() => handlePrint()} />} */}
                    {/* {orderInfo.status !== "cancelled" && orderInfo.status !== "completed" && orderInfo.status !== "user-review" && orderInfo.status !== "on-hold" && (
                      <div
                        className="cancelOrderButton"
                        onClick={() => {
                          setShowCancelModal(true);
                        }}
                      >
                        Cancel Order
                      </div>
                    )} */}
                    {orderInfo.status !== "cancelled" && orderInfo.status !== "completed" && orderInfo.status !== "user-review" && orderInfo.status !== "on-hold" &&  (
                        <NewButton
                          text={"Cancel Order"}
                          customIcon={<TRASH />}
                          back
                          whiteBtn
                          width="100px"
                          smallPadding
                          onClick={() => setShowCancelModal(true)}
                        />
                      )}

                      <NewButton
                          text={"View Invoice"}
                          back
                          icon={false}
                          whiteBtn
                          width="100px"
                          smallPadding
                          onClick={() => setOpenInvoiceModal(orderInfo)}
                        />
                  </div>
                </div>
              )}

              {loadedOrder && (
                <div className="mainOrderPageContainer">
                  <div className="mainOrderPageContainerOptions">
                    <div id="mainPrimary" className="mainOrderPrimaryContent">
                      <div className="accountSettingsMenu bg-white my-4 md:!grid-cols-4 !grid-cols-2">
                        <div
                          className="accountSettingsMenuTab"
                          onClick={() => setSelectedTab(0)}
                        >
                          <div className="accountSettingMenuTextWrap">
                            <p
                              className={`accountSettingMenuText ${selectedTab === 0 && "selectedTab"
                                }`}
                            >
                              Order Info
                            </p>
                          </div>
                          <div className="accountSettingsMenuSpacer">
                            <div></div>
                          </div>
                        </div>
                        <div
                          className="accountSettingsMenuTab"
                          onClick={() => setSelectedTab(1)}
                        >
                          <div className="accountSettingMenuTextWrap">
                            <p
                              className={`accountSettingMenuText ${selectedTab === 1 && "selectedTab"
                                }`}
                            >
                              Files
                            </p>
                          </div>
                          <div className="accountSettingsMenuSpacer">
                            <div></div>
                          </div>
                        </div>
                        <div
                          className="accountSettingsMenuTab"
                          onClick={() => setSelectedTab(2)}
                        >
                          <div className="accountSettingMenuTextWrap">
                            <p
                              className={`accountSettingMenuText ${selectedTab === 2 && "selectedTab"
                                }`}
                            >
                              Chat with client
                            </p>
                            {selectedTab !== 2 && <MessageDot chatId={orderInfo.generalChatId}/>}
                          </div>
                          <div className="accountSettingsMenuSpacer">
                            <div></div>
                          </div>
                        </div>
                        {(userData.role === AccountType.SUPPORT ||
                          userData.role === AccountType.SUPPORTPLUS ||
                          userData.role === AccountType.OWNER) && (
                            <div className="accountSettingsMenuTab" onClick={() => setSelectedTab(3)}>
                              <div className="accountSettingMenuTextWrap">
                                <p className={`accountSettingMenuText ${selectedTab === 3 && "selectedTab"}`}>
                                  eVerbary chat
                                </p>
                                {selectedTab !== 3 && <MessageDot chatId={orderInfo.everbaryChatId} type="everbary"/>}
                              </div>
                            </div>
                          )}
                      </div>
                      {selectedTab === 0 && (
                        <div className="quotePrimaryOptionsWrapper accSingleQuoteDataWrapper">
                          <div className="accSingleQuoteDataWrap">
                            <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">Assigned to</h6>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Translator
                              </p>
                              <p className="accSingleInvoiceText">
                                <TranslatorDropdown
                                  customClass={"selectTranslator"}
                                  order={orderInfo}
                                  handleUpdateTranslator={handleUpdateTranslator}
                                  clients={clients.filter(
                                    (el) =>
                                      ['Translator', 'Support','support', 'Support Plus','supportPlus'].includes(el.role)
                                  )}
                                  type={"Single Order"}
                                />
                              </p>
                            </div>
                          </div>
                          <div className="accSingleQuoteDataWrap">
                            {orderInfo.timestamp && <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">
                                Order Time Line
                              </h6>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Created
                              </p>
                              <p className="accSingleInvoiceText">
                                {formatDate(orderInfo.timestamp)}
                              </p>
                            </div>}
                            {orderInfo.assigned && <div className="accSingleQuoteDataContainer">
                              <span>
                              </span>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Assigned
                              </p>
                              <p className="accSingleInvoiceText">
                                {formatDate(orderInfo.assigned)}
                              </p>
                            </div>}
                            {orderInfo.due && <div className="accSingleQuoteDataContainer">
                              <span>
                              </span>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Due
                              </p>
                              <p className="accSingleInvoiceText">
                                {formatDate(orderInfo.due)}
                              </p>
                            </div>}
                            {orderInfo.status !== "completed" && orderInfo.status !== "user-review" && orderInfo.due && <div className="accSingleQuoteDataContainer">
                              <span>
                              </span>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Time Left
                              </p>
                              <p className="accSingleInvoiceText">
                                <OrderProgress dueTime={orderInfo.due} assignTime={orderInfo.assigned} />
                              </p>
                            </div>}
                            <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">Order Info</h6>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Language
                              </p>
                              <p className="accSingleInvoiceText">
                                {getLanguage(orderInfo.languageFrom)} to{" "}
                                {getLanguage(orderInfo.languageTo)}
                              </p>
                            </div>
                            <div className="accSingleQuoteDataContainer">
                              <p />
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Type
                              </p>
                              <p className="accSingleInvoiceText">
                                {orderInfo.certified
                                  ? "Certified Translation"
                                  : "Standard Translation"}
                              </p>
                            </div>
                            <div className="accSingleQuoteDataContainer">
                              <p />
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Size
                              </p> 
                              <div className="flex items-center gap-2">
                                <p className="accSingleInvoiceText">
                                  {orderInfo.pagesCount === "1"
                                    ? `Less Than 250 Words (${orderInfo.pagesCount} Page)`
                                    : `More Than 250 Words (${orderInfo.pagesCount} Pages)`}
                                </p>
                                {userData && userData.role === AccountType.OWNER && <TbEdit className="w-[20px] h-[20px] color-[#030F23] cursor-pointer" onClick={() => {setShowEditPagesModal(true); setEditPagesCount(orderInfo.pagesCount?? "");}} />}
                              </div>
                            </div>
                          </div>
                          <div className="accSingleQuoteDataWrap">
                            <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">Client</h6>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Name
                              </p>
                              <p className="accSingleInvoiceText capital">
                                {(userData?.role === "Support" && "Support Plus") ? "***" : orderInfo.name}
                              </p>
                            </div>
                            <div className="accSingleQuoteDataContainer">
                              <p></p>
                              <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                Email
                              </p>
                              <p className="accSingleInvoiceText">
                                {(userData?.role === "Support" && "Support Plus") ? "***@***.com" : orderInfo.email}
                              </p>
                            </div>
                          </div>
                          <div className="accSingleQuoteDataWrap">
                            <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">Services</h6>

                              {(!orderInfo.expedited || !orderInfo.expedited) && !orderInfo.notarization && !orderInfo.hardCopy && <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                No Additional Services Available
                              </p>}

                              {(orderInfo.expedited || orderInfo.expeditedPlus) && orderInfo.status === "completed" && (
                                <>
                                  <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                    {orderInfo.expeditedPlus
                                      ? "Expedited+"
                                      : "Expedited"}{" "}
                                    Turnaround
                                  </p>

                                  <div className="flex items-center">
                                    <div className={`hardCopyChecked hardCopyCheckbox mr-1`}>
                                      <Check className="hardCopyCheck" style={{ opacity: 1 }} />
                                    </div>
                                    <p className="accSingleInvoiceText">
                                      Completed
                                    </p>
                                  </div>

                                </>
                              )}
                            </div>

                            {orderInfo.notarization && orderInfo.status === "completed" && (
                                <div className="accSingleQuoteDataContainer">
                                  <p></p>
                                  <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                    Notarization
                                  </p>

                                  {orderInfo.status !== "completed" ? <p className="accSingleInvoiceText"><p className="clientsApprovaltext">Available After Client's Approval</p></p> :
                                    <div className="flex items-center">
                                      <div className={`${notarizationService ? "hardCopyChecked" : ""} hardCopyCheckbox mr-1`}>
                                        <Check className="hardCopyCheck" onClick={() => {
                                          if (orderInfo.notarization && !notarizationService) {
                                            handleNotarizationClick();
                                          }
                                        }} style={{ opacity: notarizationService ? 1 : 0 }} />
                                      </div>
                                      <p className="accSingleInvoiceText">
                                        Completed
                                      </p>
                                    </div>
                                  }

                                </div>
                              )}

                            {orderInfo.hardCopy && orderInfo.status === "completed" && (
                                <div className="accSingleQuoteDataContainer">
                                  <p></p>
                                  <p className="accSingleInvoiceText accSingleInvoiceSubText">
                                    Mail Hard Copy
                                  </p>
                                  <p className="accSingleInvoiceText capital">
                                    {getFullAddress(orderInfo.hardCopyExtra)}<br/><span className="font-[600]">{orderInfo.hardCopyExtra.method ? " (USPS " + orderInfo.hardCopyExtra.method + (orderInfo.hardCopyExtra.requireSignature ? " - required signature" :"") + ")" : ""}</span>
                                    {orderInfo.status !== "completed" ? <p className="accSingleInvoiceText"><p className="clientsApprovaltext mb-1">Available After Client's Approval</p></p> :
                                      <div className="flex flex-col gap-1 mt-1">
                                       
                                        <FormTextInput
                                          placeholder="Tracking ID"
                                          value={trackingID}
                                          onChange={setTrackingID}
                                          disabled={hardCopyService}
                                        />
                                        <div className="flex items-center mt-1">
                                          <div style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }} className={`${trackingID && hardCopyService ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
                                            <Check className="hardCopyCheck" onClick={() => {
                                              if (trackingID && !hardCopyService) {
                                                handleHardCopyClick();
                                              }
                                            }}
                                              style={{ opacity: trackingID && hardCopyService ? 1 : 0 }} />
                                          </div>
                                          Shipped
                                        </div>

                                      </div>
                                    }
                                  </p>
                                </div>
                              )}
                          </div>
                          {orderInfo && orderInfo.translatorCertification && <div className="accSingleQuoteDataWrap">
                            <div className="accSingleQuoteDataContainer">
                              <h6 className="accSingleQuoteTitle">Individual Translator Certification</h6>
                              <p className="accSingleInvoiceText">
                                  <CHECK />
                                </p>

                            </div>
                          </div>}
                        </div>
                      )}

                      {selectedTab === 0 && orderInfo.notes && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">General Notes</h4>
                          {orderInfo.notes && orderInfo.notes.blocks ? (
                            editorState.getCurrentContent().getPlainText() !==
                            "" && (
                              <div className="accSingleInvoiceText">
                                <Editor
                                  editorState={editorState}
                                  onChange={(editorState) =>
                                    setEditorState(editorState)
                                  }
                                  readOnly
                                />
                              </div>
                            )
                          ) : (
                            <p className="accSingleInvoiceText">
                              {orderInfo.notes
                                ? orderInfo.notes
                                : orderInfo.clientNotes}
                            </p>
                          )}
                        </div>
                      )}

                      {(selectedTab === 0 && ((orderInfo.type && orderInfo.type === "business") || orderInfo.teamId)) && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">Your Client</h4>
                          <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                            If submitted, the client field will be included in
                            emails, in translations, and in your invoice.
                          </h6> 

                          <div className="accSingleOrderCCEmailWrap">
                            <FormTextInput
                              placeholder="Client First Name"
                              value={clientFirstName}
                              onChange={setClientFirstName}
                              onKeyDown={(e) =>
                                e.key === "Enter" &&
                                handleSaveClientName()
                              }
                              disabled={!(userData && (( userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client"))}
                            />
                            <FormTextInput
                              placeholder="Client Last Name"
                              value={clientLastName}
                              onChange={setClientLastName}
                              onKeyDown={(e) =>
                                e.key === "Enter" &&
                                handleSaveClientName()
                              }
                              disabled={!(userData && (( userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client"))}
                            />
                            <NewButton
                              width="86px"
                              text={saveClientBtnTxt}
                              back
                              whiteBtn
                              icon={false}
                              onClick={() => {
                                handleSaveClientName();
                              }}
                              disabled={
                                clientFirstName === "" ||
                                saveClientBtnTxt === "Saving.." || 
                                !(userData && (( userData.teamId && orderInfo.teamId && userData.teamId === orderInfo.teamId) || userData.role !== "client"))
                              }
                            />
                          </div> 
                        </div>
                      )}

                      {selectedTab === 0 && howDidYouHear && howDidYouHear.selectedOption && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">How did they hear about us</h4>
                          <h6 className="accSingleInvoiceText accSingleInvoiceSubText capitalize mt-2">
                            {howDidYouHear.selectedOption} {howDidYouHear.hasInput && `: ${howDidYouHear.inputText}`}
                          </h6> 
                        </div>
                      )}

                      {/* {selectedTab === 0 && (
                        <div className="quotePrimaryOptionsWrapper">
                          <h4 className="quotePrimaryTitle">
                            CC{"'"}ed to This Order
                          </h4>
                          <h6 className="accSingleInvoiceText accSingleInvoiceSubText">
                            All added people will receive email notifications
                            about the details of the order, its updates, and will
                            be able to download the translation.
                          </h6>

                          {userData && userData.id === orderInfo.userID && (
                            <div className="accSingleOrderCCEmailWrap">
                              <FormTextInput
                                placeholder="User's email"
                                value={newCCEmail}
                                onChange={setNewCCEmail}
                                onKeyDown={(e) =>
                                  e.key === "Enter" && addCCedEmail(newCCEmail)
                                }
                              />
                              <NewButton
                                width="86px"
                                text={addCCEmailBtnTxt}
                                back
                                whiteBtn
                                icon={false}
                                onClick={() => {
                                  addCCedEmail();
                                }}
                                disabled={
                                  newCCEmail === "" ||
                                  addCCEmailBtnTxt === "Adding.."
                                }
                              />
                            </div>
                          )}

                          {newCCEmail !== "" && (
                            <div className="accSingleOrderTeamUsers">
                              {teamUsers
                                .filter(
                                  (u) =>
                                    u.email.includes(newCCEmail) &&
                                    ccedEmails.length > 0 &&
                                    !ccedEmails.includes(u.email)
                                )
                                .map((user) => (
                                  <p
                                    className="accSingleInvoiceText"
                                    onClick={() => addCCedEmail(user.email)}
                                  >
                                    {user.email}
                                  </p>
                                ))}
                            </div>
                          )}

                          {ccedEmails.map((email) => (
                            <div className="accSingleOrderCCEmails">
                              <p className="accSingleInvoiceText">{email}</p>
                              {userData && userData.id === orderInfo.userID && (
                                <CROSS
                                  onClick={() => removeCCedEmail(email)}
                                  className="accSingleOrderOrderCCRemoveIcon"
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      )} */}

                      {selectedTab === 0 && orderInfo.status === "completed" && orderInfo.reviewRating && (
                        <div className="quotePrimaryOptionsWrapper">
                            <div className="accSingleOrderMoreBtnWrap">
                              <h4 className="quotePrimaryTitle">Review</h4>
                            </div>
                            <div
                              className="accSingleOrderReviewWrap"
                              style={{ marginTop: "8px" }}
                            >
                              <div className="accSingleOrderStarWrap">
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${orderInfo.reviewRating > 0
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`} 
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${orderInfo.reviewRating > 1
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${orderInfo.reviewRating > 2
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${orderInfo.reviewRating > 3
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                />
                                <EMPTYSTAR
                                  className={`accSingleOrderStar ${orderInfo.reviewRating > 4
                                    ? "accSingleOrderStarSelected"
                                    : ""
                                    }`}
                                />
                              </div>
                              {orderInfo.reviewText && (
                                <p className="accSingleInvoiceText">
                                  {orderInfo.reviewText}
                                </p>
                              )}
                              {/* <NewButton text="Edit Review" onClick={() => setShowReviewPopUp(true)} smallPadding={true}/> */}
                            </div>
                        </div>
                      )}

                      {selectedTab === 0 &&
                        (orderInfo.status === 'in-progress' || ((orderInfo.status === 'support-review' || orderInfo.status === 'revision' || orderInfo.status === 'user-review' || orderInfo.status === 'completed') && userData && (userData.role === 'owner' || userData.role === 'Support'))) && <div className="quotePrimaryOptionsWrapper">
                          <p className="quotePrimaryTitle mb-1.5">Comment History</p>
                          <>
                            
                            {userData && (userData.role === 'owner' || userData.role === 'Support') && (orderInfo.supportReply || openReplyBox) &&
                              <div className="singleTranslationNotesContainer">
                                <div className="singleTranslationNotesTitle border-none bg-transparent text-black pl-0 font-medium">
                                  <strong>Support's Notes (for Client)</strong>
                                  <div className="singleOrderTextButtons">
                                    <Bold className="singleOrderRichTextButton" onClick={() => handleBoldClick('supportReply')} />
                                    <Italic className="singleOrderRichTextButton" onClick={() => handleItalicClick('supportReply')} />
                                    <Underline className="singleOrderRichTextButton" onClick={() => handleUnderlineClick('supportReply')} />
                                    <List className="singleOrderRichTextButton" onClick={() => toggleUL('supportReply')} />
                                    <div className="singleTranslationNotesAuxButton" onClick={() => saveSupportReply()}>
                                      Save
                                    </div>
                                  </div>
                                </div>
                                <div className="singleTranslationRichTextEditor no-scrollbar rounded-[6px]">
                                  <Editor
                                    editorState={supportReplyNotes}
                                    onChange={supportReplyNotes => setSupportReplyNotes(supportReplyNotes)}
                                  />
                                </div>
                              </div>
                            }
                            {((userData && (userData.role === 'owner' || userData.role === 'Support')) || (userData && userData.role === 'Translator' && supportNotes.getCurrentContent().getPlainText() !== '' && (orderInfo.status === 'in-progress' || orderInfo.status === 'revision' || orderInfo.status === 'user-review'))) &&
                              <div className="singleTranslationNotesContainer">
                                <div className="singleTranslationNotesTitle border-none bg-transparent text-black pl-0 font-medium">
                                  <strong>Support's Notes (for Translator)</strong>
                                  {userData && (userData.role === 'Support' || userData.role === 'owner') && (orderInfo.status === 'in-progress' || orderInfo.status === 'support-review') &&
                                    <div className="singleOrderTextButtons">
                                      <Bold className="singleOrderRichTextButton" onClick={() => handleBoldClick('supportNotes')} />
                                      <Italic className="singleOrderRichTextButton" onClick={() => handleItalicClick('supportNotes')} />
                                      <Underline className="singleOrderRichTextButton" onClick={() => handleUnderlineClick('supportNotes')} />
                                      <List className="singleOrderRichTextButton" onClick={() => toggleUL('supportNotes')} />
                                      <div className="singleTranslationNotesAuxButton" onClick={() => saveSupportNotes()}>
                                        Save
                                      </div>
                                    </div>
                                  }
                                </div>
                                <div className="singleTranslationRichTextEditor no-scrollbar rounded-[6px]" >
                                  <Editor
                                    editorState={supportNotes}
                                    onChange={supportNotes => setSupportNotes(supportNotes)}
                                    readOnly={!userData || userData.role === 'Translator' || !(orderInfo.status === 'in-progress' || orderInfo.status === 'support-review')}
                                  />
                                </div>
                              </div>
                            }
                            {(orderInfo.status === 'support-review' || orderInfo.status === 'user-review' || orderInfo.status === 'completed') && translatorNotes.getCurrentContent().getPlainText() !== '' && userData && (userData.role === 'Support' || userData.role === 'owner') &&
                              <div className="singleTranslationNotesContainer">
                                <div className="singleTranslationNotesTitle bg-transparent text-black border-none pl-0 font-medium">
                                  <strong>Translator Revision Notes</strong>
                                </div>
                                <div className="singleTranslationRichTextEditor no-scrollbar rounded-[6px]">
                                  <Editor
                                    editorState={translatorNotes}
                                    onChange={translatorNotes => setTranslatorNotes(translatorNotes)}
                                    readOnly
                                  />
                                </div>
                              </div>
                            }
                            {clientRevisionNotes.getCurrentContent().getPlainText() !== '' && userData && (userData.role === 'Support' || userData.role === 'owner') && <div className="singleTranslationNotesContainer">
                              <div className="singleTranslationNotesTitle bg-transparent text-black border-none pl-0 font-medium"><strong>Client's Revision Request</strong></div>
                              <div className="singleTranslationRichTextEditor no-scrollbar rounded-[6px]">
                                <Editor
                                  editorState={clientRevisionNotes}
                                  onChange={editorState => setClientRevisionNotes(editorState)}
                                  readOnly
                                />
                              </div>
                            </div>
                            }
                            {(orderInfo.status === 'support-review' || orderInfo.status === 'user-review' || orderInfo.status === 'completed') && translatorNotesClient.getCurrentContent().getPlainText() !== '' && userData && (userData.role === 'Support' || userData.role === 'owner') &&
                              <div className="singleTranslationNotesContainer">
                                <div className="singleTranslationNotesTitle text-black border-none pl-0 font-medium">
                                  <strong>Translator Revision Notes (for Client)</strong>
                                </div>
                                <div className="singleTranslationRichTextEditor no-scrollbar rounded-[6px]">
                                  <Editor
                                    editorState={translatorNotesClient}
                                    onChange={translatorNotesClient => setTranslatorNotesClient(translatorNotesClient)}
                                    readOnly
                                  />
                                </div>
                              </div>
                            }
                          </>
                        </div>}


                      {selectedTab === 1 && (
                        <>
                          {/* Cover Sheet */}
                          <div className="quotePrimaryOptionsWrapper">
                            <div className="w-full flex flex-wrap gap-4 items-center justify-between">
                              <h4 className="quotePrimaryTitle text-center lg:text-left">Coversheet</h4>

                              <div className="flex justify-center lg:justify-start flex-1">
                                <input
                                  className="accountDetailsSearchInput w-full max-w-md min-w-[200px]"
                                  placeholder="Document Name"
                                  value={documentName}
                                  onChange={(e) => setDocumentName(e.target.value)}
                                  disabled={loading}
                                />
                              </div>

                              <div className="flex justify-center">
                                <NewButton
                                  disabled={!documentName || loading}
                                  back={true}
                                  icon={false}
                                  text={"Generate Coversheet"}
                                  onClick={generateCoversheet}
                                />
                              </div>
                            </div>
                            {orderInfo.files
                              .filter(
                                (f) =>
                                  f.type === "coversheet"
                              ).length > 0 && <div className="accSingleQuoteFileWrap mt-2">
                                {orderInfo.files
                                  .filter(
                                    (f) =>
                                      f.type === "coversheet"
                                  )
                                  .map((file, index) => (
                                    <>
                                      <div
                                        key={index}
                                        className="fileUploaderLineOuter"
                                      >
                                        <div className="fileUploaderLine">
                                          <div className="fileUploaderLineInfo flex-1">
                                            <GetFileTypeElement file={file}/>
                                            <p
                                              className="fileUploaderLineName"
                                            >
                                              {file.name}
                                            </p>
                                          </div>
                                          {file.status !== "uploading" &&
                                            file.timestamp && (
                                              <p className="fileUploaderLineSize max-sm:hidden">
                                                {formatDate(file.timestamp)}
                                              </p>
                                            )}

                                          {file.status === "uploading" ? (
                                            <div className="fileUploaderLineProgressContainer">
                                              <animated.div
                                                style={{
                                                  width: `${file.progress}%`,
                                                }}
                                                className="fileUploaderLineProgress"
                                              />
                                            </div>
                                          ) : null}
                                           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', gap: '5px' }}>
                                            <DOWNLOAD
                                              className="fileUploaderLineIcon"
                                              onClick={() => {
                                                downloadCoverSheetFile(file);
                                              }}
                                            />
                                            <button
                                                className="commentBtn"
                                                onClick={() => {
                                                  deleteFileFromOrderHandler(file);
                                                }}
                                              >
                                                <TRASH />
                                              </button>
                                            </div>
                                        </div>
                                      </div>
                                      {orderInfo.files.length - 1 !== index && (
                                        <div className="accSingleQuoteFileDivider"></div>
                                      )}
                                    </>
                                  ))}
                              </div>}

                          </div>

                          {/* Translated Files */}
                          <div className="quotePrimaryOptionsWrapper">
                            <div className="w-full flex justify-between items-center">

                              <div className="memberOrderStatus">
                                {showTranslatedFileHoverBox && (
                                  <div className="teamStatusHover">
                                    <p className="subTitle">{'To send for quality check, you need to prepare the translation file in .docx and .pdf formats.'}</p>
                                  </div>
                                )}
                                <h4 className="quotePrimaryTitle">Translated Files</h4>
                                <Info className="statusIcon" onMouseOver={() => handleMouseOver()}
                                  onMouseOut={handleMouseOut} />

                              </div>

                              { <div >

                                  <NewButton
                                    back={true}
                                    text={"Add New File"}
                                    customIcon={<Plus className="h-4 w-4" />}
                                    onClick={() => setShowAddTranslatedFiles(true)}
                                  />
                                </div>
                              }

                            </div>
                            {orderInfo.files
                              .filter(
                                (f) =>
                                  f.type === "translation"
                              ).length > 0 && <div className="accSingleQuoteFileWrap mt-2">
                                {orderInfo.files
                                  .filter(
                                    (f) =>
                                      (f.type === "translation" 
                                        // ||
                                        // (f.type === "revision" &&
                                        //   (orderInfo.status === "user-review" || orderInfo.status === "revision" ||
                                        //     orderInfo.status === "completed"))
                                          ) 
                                     
                                  )
                                  .map((file, index) => (
                                    <>
                                      <div
                                        key={index}
                                        className="fileUploaderLineOuter"
                                      >
                                        <div className="fileUploaderLine">
                                          <div className="fileUploaderLineInfo flex-1 relative">
                                            <GetFileTypeElement file={file}/>
                                            {file.name &&
                                            file.name.length > 14 &&
                                            showDetailModal === file.ref && (
                                            <div className="accountdetailHoverBox left-[50px] top-full">
                                            <p
                                                className="text-[13px] font-normal leading-normal letter-spacing-[-0.01em]"
                                            >
                                                {file.name}
                                            </p>
                                            </div>
                                          )}
                                            <p
                                              className="fileUploaderLineName"
                                              onMouseOver={() =>
                                                setShowDetailModal(file.ref)
                                              }
                                              onMouseLeave={() => setShowDetailModal("")}
                                            >
                                              {file.name}
                                            </p>
                                            {file.refLabel && file.refLabel.length > 0 &&
                                          <div className="flex flex-row gap-1 max-md:hidden">
                                            {file.refLabel.map((label) => (
                                            <span style={{ backgroundColor: REF_LABELS_COLORS[label] }} className={`accFilesRevisedText capitalize`}>
                                              {label}
                                            </span>
                                            ))}
                                          </div>
                                          }
                                          </div>
                                          {file.status !== "uploading" &&
                                            file.timestamp && (
                                              <p className="fileUploaderLineSize max-sm:hidden">
                                                {formatDate(file.timestamp)}
                                              </p>
                                            )}
                                          {file.status === "uploading" ? (
                                            <div className="fileUploaderLineProgressContainer">
                                              <animated.div
                                                style={{
                                                  width: `${file.progress}%`,
                                                }}
                                                className="fileUploaderLineProgress"
                                              />
                                            </div>
                                          ) : null}
                                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', gap: '5px' }}>
                                            <DOWNLOAD
                                              className="hardCopyAddressIcon"
                                              style={{ cursor: 'pointer' }}
                                              onClick={() => handleDownloadFile(file)}
                                            />
                                            <button
                                              className="commentBtn"
                                              onClick={() => {
                                                deleteFileFromOrderHandler(file);
                                              }}
                                            >
                                              <TRASH />
                                            </button>
                                          </div>
                                          {/*More option source file */}
                                        <div
                                          className="hardCopyAddressIconWrap"
                                        >
                                          {filesMoreOptions === file.ref ? (
                                            <MORESELECTED className="hardCopyAddressIcon" onClick={(e) => {
                                              e.stopPropagation();
                                              setFilesMoreOptions(null)
                                            }} />
                                          ) : (
                                            <MORE
                                              className="hardCopyAddressIcon"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setFilesMoreOptions(file.ref);
                                              }}
                                            />
                                          )}

                                          {filesMoreOptions === file.ref && (
                                            <div className="hardCopyAddressEditWrap">
                                              {file.refLabel && file.refLabel.includes("revised") ? 
                                                <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  handleDeleteRefLabel("revised", file);
                                                }}
                                              >
                                                Remove ‘Revised’ label
                                              </div>
                                              : <div
                                                  className="hardCopyAddressEdit"
                                                  onClick={() => {
                                                    handleAddRefLabel("revised", file);
                                                  }}
                                                >
                                                  Add ‘Revised’ label
                                              </div>}

                                             { file.refLabel && file.refLabel.includes("reference") ? 
                                             <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  handleDeleteRefLabel("reference", file);
                                                }}
                                              >
                                                Remove ‘Reference’ label
                                              </div> : <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  handleAddRefLabel("reference", file);
                                                }}
                                              >
                                                Add ‘Reference’ label
                                              </div>}
                                              
                                              {
                                               file.refLabel && file.refLabel.includes("notarized") ? 
                                                <div
                                                  className="hardCopyAddressEdit"
                                                  onClick={() => {
                                                    handleDeleteRefLabel("notarized", file);
                                                  }}
                                                >
                                                  Remove Notarized label
                                                </div>
                                               : orderInfo.status === "completed" ? <div
                                                  className="hardCopyAddressEdit"
                                                  onClick={() => {
                                                    handleAddRefLabel("notarized", file);
                                                  }}
                                                >
                                                  Add Notarized label
                                                </div> : ""
                                              }
                                            </div>
                                          )}
                                        </div>
                                        </div>
                                      </div>
                                      {orderInfo.files.length - 1 !== index && (
                                        <div className="accSingleQuoteFileDivider"></div>
                                      )}
                                    </>
                                  ))}
                              </div>}

                          </div>

                          {/* Source Files */}
                          <div className="quotePrimaryOptionsWrapper">

                            <div className="w-full flex justify-between items-center">

                              <div className="memberOrderStatus">

                                <h4 className="quotePrimaryTitle">Source Files</h4>

                              </div>

                              { <div>
                                <NewButton
                                  back={true}
                                  text={"Add New File"}
                                  customIcon={<Plus className="h-4 w-4" />}
                                  onClick={() => setShowAddSourcefiles(true)}
                                />
                              </div>}

                            </div>
                            <div className="accSingleQuoteFileWrap mt-2">
                              {orderInfo.files
                                .filter(
                                  (f) =>
                                    f.type === "source" ||
                                    f.type === "reference" ||
                                    f.type === "client"
                                )
                                .map((file, index) => (
                                  <>
                                    <div
                                      key={index}
                                      className="fileUploaderLineOuter"
                                    >
                                      <div className="fileUploaderLine">
                                        <div className="fileUploaderLineInfo relative">
                                          <GetFileTypeElement file={file}/>

                                          {file.name &&
                                            file.name.length > 14 &&
                                            showDetailModal === file.ref && (
                                            <div className="accountdetailHoverBox left-[50px] top-full">
                                            <p
                                                className="text-[13px] font-normal leading-normal letter-spacing-[-0.01em]"
                                            >
                                                {file.name}
                                            </p>
                                            </div>
                                          )}
                                          <p
                                            className="fileUploaderLineName w-max"
                                            onMouseOver={() =>
                                              setShowDetailModal(file.ref)
                                            }
                                            onMouseLeave={() => setShowDetailModal("")}
                                          >
                                
                                            {file.name}
                                          </p>
                                          
                                          <div className="relative"  
                                          onMouseOver={() => {
                                              setFileIconTooltip(file.ref);
                                            }}
                                            onMouseLeave={() => {
                                              setFileIconTooltip("");
                                            }}
                                            onClick={() =>
                                              copyFileName(file)
                                            }
                                          >
                                          {fileIconTooltip === file.ref ? (
                                            <Copy />
                                          ) : (
                                            <CopyunSelect
                                            />
                                          )}
                                          {fileIconTooltip === file.ref && window.innerWidth > 768 && (
                                            <div className="absolute top-[-10px] right-[100%] bg-white px-1.5 py-1 text-[13px] rounded-md shadow-md min-w-max whitespace-nowrap z-50">
                                              {fileOverlayText}
                                            </div>
                                          )}
                                        </div>
                                        
                                          {file.refLabel && file.refLabel.length > 0 &&
                                          <div className="flex flex-row gap-1 max-md:hidden">
                                            {file.refLabel.map((label) => (
                                            <span style={{ backgroundColor: REF_LABELS_COLORS[label] }} className={`accFilesRevisedText capitalize`}>
                                              {label}
                                            </span>
                                            ))}
                                          </div>
                                          }
                                        </div>
                                        {file.status !== "uploading" &&
                                          file.timestamp && (
                                            <p className="fileUploaderLineSize max-sm:hidden">
                                              {formatDate(file.timestamp)} 
                                            </p>
                                          )}

                                        {file.status === "uploading" ? (
                                          <div className="fileUploaderLineProgressContainer">
                                            <animated.div
                                              style={{
                                                width: `${file.progress}%`,
                                              }}
                                              className="fileUploaderLineProgress"
                                            />
                                          </div>
                                        ) : null}

                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', gap: '5px' }}>
                                          <DOWNLOAD
                                            className="hardCopyAddressIcon"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleDownloadFile(file)}
                                          />
                                          <button
                                            className="commentBtn"
                                            onClick={() => {
                                              setShowDeleteModal(file)
                                            }}
                                          >
                                            <TRASH />
                                          </button>

                                        </div>
                                        {/*More option source file */}
                                        <div
                                          className="hardCopyAddressIconWrap"
                                        >
                                          {filesMoreOptions === file.ref ? (
                                            <MORESELECTED className="hardCopyAddressIcon" onClick={(e) => {
                                              e.stopPropagation();
                                              setFilesMoreOptions(null)
                                            }} />
                                          ) : (
                                            <MORE
                                              className="hardCopyAddressIcon"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setFilesMoreOptions(file.ref);
                                              }}
                                            />
                                          )}

                                          {filesMoreOptions === file.ref && (
                                            <div className="hardCopyAddressEditWrap">
                                              {file.refLabel && file.refLabel.includes("revised") ? 
                                                <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  handleDeleteRefLabel("revised", file);
                                                }}
                                              >
                                                Remove ‘Revised’ label
                                              </div>
                                              : <div
                                                  className="hardCopyAddressEdit"
                                                  onClick={() => {
                                                    handleAddRefLabel("revised", file);
                                                  }}
                                                >
                                                  Add ‘Revised’ label
                                              </div>}

                                             { file.refLabel && file.refLabel.includes("reference") ? 
                                             <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  handleDeleteRefLabel("reference", file);
                                                }}
                                              >
                                                Remove ‘Reference’ label
                                              </div> : <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  handleAddRefLabel("reference", file);
                                                }}
                                              >
                                                Add ‘Reference’ label
                                              </div>}
                                              <div
                                                className="hardCopyAddressEdit"
                                                onClick={() => {
                                                  setAiModalFile(file);
                                                  setFilesMoreOptions(false);
                                                }}
                                              >
                                                Process with AI
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>

                                    </div>
                                    {orderInfo.files.length - 1 !== index && (
                                      <div className="accSingleQuoteFileDivider"></div>
                                    )}
                                  </>
                                ))}
                            </div>
                          </div>
                        </>
                      )}


                      {selectedTab === 2 && (
                        <div className="quotePrimaryOptionsWrapper">
                          <OrderChatBox
                            userId={userData.id}
                            userRole={userData.role}
                            orderChatId={orderInfo.generalChatId || null}
                            orderData={orderInfo}
                            userData={userData}
                          />
                        </div>
                      )}

                      {selectedTab === 3 &&
                        (userData.role === AccountType.OWNER ||
                          userData.role === AccountType.SUPPORT ||
                          userData.role === AccountType.SUPPORTPLUS) && (
                          <div className="quotePrimaryOptionsWrapper">
                            <EverbaryChatBox 
                              userId={userData.id}
                              userRole={userData.role}
                              orderChatId={orderInfo.everbaryChatId || null}
                              orderData={orderInfo}
                              userData={userData} />
                          </div>
                        )}

                    </div>
                  </div>

                  <div className="mainOrderSecondaryContent">
                    <div className="mainOrderSecondaryContentWrap">
                      <div style={{ marginTop: "0.5rem" }}>


                        {orderInfo.status === "support-review" || orderInfo.status === "in-progress" || orderInfo.status === "revision" ? <OrderTranslation windowSize={windowSize} orderInfo={orderInfo} setOrderUpdated={setOrderUpdated} clientRevisionNotes={clientRevisionNotes} /> : ""}

                        
                        <div className="orderSummary flex flex-col gap-2">
                        {(orderInfo.orderInvoiceId) &&
                          <NewButton text="Go to Invoice" icon={false} width="100%" onClick={() => transitionTo(`/office/invoice/${orderInfo.orderInvoiceId}`)}/>
                        }
                        {(!orderInfo.orderInvoiceId) &&
                          <NewButton text="Mark as Paid" icon={false} width="100%" onClick={() => setShowMaunallyPayModal(true)}/>
                        }
                        {orderInfo.status === "on-hold" && orderInfo.cancellationHold &&
                          <NewButton text="Approve Cancellation" icon={false} width="100%" deleteBtn={true} onClick={() => setShowApproveCancellation(true)}/>
                        }
                        </div>


                        {showTranslationApproval && (orderInfo.status === "completed" && (hardCopyService || notarizationService) ? <OrderTranslationAfterApprove orderInfo={orderInfo}
                          notarizationService={notarizationService} hardCopyService={hardCopyService} trackingID={trackingID} setShowTranslationApproval={setShowTranslationApproval} /> : "")}


                        <OrderSummary
                          order={orderInfo}
                          certified={orderInfo.certified}
                          pagesCount={orderInfo.pagesCount}
                          languageFrom={orderInfo.languageFrom}
                          languageTo={orderInfo.languageTo}
                          discount={orderInfo.discount}
                          showBtn={
                            checkAutoBilling(teamData)
                              ? false
                              : orderInfo.paypalOrderID &&
                              orderInfo.paypalOrderID === "pay-later"
                          }
                          sendPaymentLinkBtn={
                            checkAutoBilling(teamData)
                              ? false
                              : signedIn &&
                              userData &&
                              orderInfo &&
                              orderInfo.paypalOrderID &&
                              orderInfo.paypalOrderID === "pay-later"
                          }
                          handleBtnSubmit={(e) => {
                            transitionTo(`/make-payment/order/${orderInfo.id}`);
                          }}
                          disableBtn={false}
                          btnText={"Pay"}
                          onClickPaymentLink={() => {
                            setSelectedSendPayment(orderInfo);
                          }}
                        />
                      </div>
                      <SecureAndPrivate hideNeedHelp />
                    </div>
                  </div>
                </div>
              )}
            </AccountNavBar>
          </>

        )}
    </>
  );
};

export default SingleOrderBackend;
